export const avatarKeys = {
    avatar: () => ['avatar'],
    image: (id, updatedAt) => ['avatar', 'image', id, updatedAt]
};
//# sourceMappingURL=avatar.keys.js.map